import { axiosClient } from "@/api/axios";

export function exportLessons() {
  return axiosClient.get("export/excel/lessons");
}

export function exportStudentsReport(year, onlyActive, userActiveRole) {
  return axiosClient.get(
    `export/excel/${userActiveRole}/students/report/${year}?only-active=${onlyActive}`
  );
}

export function getSemesterInfo(selectedSemester, onlyActive, userActiveRole) {
  return axiosClient.get(
    `export/excel/${userActiveRole}/semesters/${selectedSemester}?only-active=${onlyActive}`
  );
}

export function exportStudyPlan(userActiveRole) {
  return axiosClient.get(`export/excel/${userActiveRole}/study-plan/report`);
}
